import { capitalize } from "lodash";

export function getFullPresenceDisplay(presence, message) {
  let content = presence === "dnd" ? "DND" : capitalize(presence);
  if (message) content += ` - ${message}`;
  return content.replaceAll("_", " ");
}
